import { Box, Divider, styled } from '@/shared/ui';

import { SelectableCardGroup } from './selectableCardGroup';

export const PaymentInfoContainer = styled(Box)`
  background-color: ${({ theme }) => theme.palette.custom.grey7};
  padding: 35px 25px 25px;
`;

export const StyledDivider = styled(Divider)`
  margin: 16px 0;
`;

export const StyledEndDivider = styled(Divider)`
  margin: 25px 0;
`;

export const StyledSelectableCardGroup = styled(SelectableCardGroup)`
  padding: 25px 25px 0;
`;

export const BoldSpan = styled('span')`
  font-weight: bold;
`;
